import React from 'react'

import { HouseStudyDayGlobalSeasonalPriceField } from './components/HouseStudyDayGlobalSeasonalPriceField'
import { HouseStudyDayGlobalFieldProps } from '../../../form-container/HouseStudyDayGlobalFormContainer'

export const HouseStudyDayGlobalSeasonalPricesFields = (
  props: HouseStudyDayGlobalFieldProps,
) => {
  return (
    <>
      <HouseStudyDayGlobalSeasonalPriceField {...props} name='lowPrice' />

      <HouseStudyDayGlobalSeasonalPriceField {...props} name='mediumPrice' />

      <HouseStudyDayGlobalSeasonalPriceField {...props} name='highPrice' />
    </>
  )
}
